import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-yellow-tag',
    templateUrl: './yellow-tag.component.html',
    styleUrls: ['./yellow-tag.component.scss'],
    standalone: true
})
export class YellowTagComponent {

  constructor() { }

}
